module.exports = __webpack_public_path__ + "img/FI27898877.4c59b247.svg";